import React, { useState,useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import MeteoData from './MeteoData';
import MeteoAlarmas from './MeteoAlarmas';
import MeteoParametrizacion from "./MeteoParametrizacion"
import './VerMeteo.css';

function VerMeteo() {
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    
    window.addEventListener("orientationchange", function(){
        window.location.reload();
    });

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "ParamsMet");
    const [paramsDisabled,setParamsDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === true){
        setParamsDisabled(
            <Tab eventKey="parametrizacion" title="Parametrización">
                    <MeteoParametrizacion code={code} />
            </Tab>
        );
        }
    },[]);


    return (
        <div className='div-tabs-meteo'>
            <Tabs defaultActiveKey="datos">
                <Tab eventKey="datos" title="Datos">
                    <MeteoData code={code} />
                </Tab>
                <Tab eventKey="alarmas" title="Alarmas">
                    <MeteoAlarmas code={code} />
                </Tab>
                {paramsDisabled}
            </Tabs>
        </div>
    );
};

export default VerMeteo;